/**
 * Created by lu on 2017/7/22.
 */
var nb = require('../../nb');
module.exports = nb.define({
        view: {
            tag: 'input',
            type: nb.bind('type'),
            id:nb.bind('id'),
            value: nb.bind('value',{
                event:'change'
            }),
            placeholder: nb.bind('placeholder'),
            readonly: nb.bind('readonly'),
            min:nb.bind('min'),
            name:nb.bind('inputName'),
            maxlength:nb.bind('numLength'),
            'data-check':nb.bind('checkStatus'),
            disabled:nb.bind('disabled'),
            checked:nb.bind('checked')
        },
        method: {
            onModelReady: function (inModel) {
                this.$().on('blur', function () {  //当元素失去焦点时发生 blur 事件。
                    inModel.set('blur', new Date());
                });
                inModel.onChange('focus',function (inEvent) {
                    this.$().focus();
                },this);
                inModel.onChange('value',function (inEvent) {
                    inModel.set('errorStatus','');
                    inModel.set('errorMsg','');
                },this);
            }
        }
    });


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/Input.js
// module id = 7
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32